import { motion } from "framer-motion";
import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface PageContainerProps {
  children: ReactNode;
  className?: string;
}

/** Wrapper standard di pagina: max-w 7xl, padding, fade-in 200ms. */
export function PageContainer({ children, className }: PageContainerProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className={cn("mx-auto max-w-7xl px-6 py-10 space-y-8", className)}
    >
      {children}
    </motion.div>
  );
}
